var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#AAAAA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7531 10.5H12.9339C9.95819 10.5 7.5 12.9582 7.5 15.9339V25.2491C7.5 28.2249 9.95819 30.683 12.9339 30.683H29.6237C32.5994 30.683 35.0576 28.2249 35.0576 25.2491V15.9339C35.187 12.9582 32.7288 10.5 29.7531 10.5ZM32.5994 25.3785C32.5994 26.9311 31.3056 28.2249 29.7531 28.2249H12.9339C11.3814 28.2249 10.0876 26.9311 10.0876 25.3785V16.0633C10.0876 14.5107 11.3814 13.2169 12.9339 13.2169H29.6237C31.1763 13.2169 32.47 14.5107 32.47 16.0633V25.3785H32.5994Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3433 23.0496L17.3326 20.4621L13.9688 25.896H30.0117L25.3541 17.7451L21.3433 23.0496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8499 17.7453C18.6359 17.7453 19.2731 17.1081 19.2731 16.3221C19.2731 15.5361 18.6359 14.8989 17.8499 14.8989C17.0639 14.8989 16.4268 15.5361 16.4268 16.3221C16.4268 17.1081 17.0639 17.7453 17.8499 17.7453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBw);
export default __webpack_public_path__ + "static/media/img_bw.10f5c0aaf80789774e0ec4b4ece1fbdd.svg";
export { ForwardRef as ReactComponent };